export default {"src":"/_next/static/media/ellipse-personalized.9c1ecb10.svg","height":820,"width":1620,"blurWidth":0,"blurHeight":0};